<template>
    <div>
        <loader v-if="isLoading||isLoadingEdit" />
        <!-- Botão de Salvar -->
        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <!-- Enviar para aprovação -->
                <button
                    v-if="
                        (acertoDespesa.situacao==3 &&
                        acertoDespesa.iddes_acerto_despesa!=null &&
                        !cantEdit &&
                        valorTotalDespesas!=0)
                        ||
                        (acertoDespesa.situacao==5 &&
                        acertoDespesa.iddes_acerto_despesa!=null)
                    "
                    class="save-btn is-approve"
                    type="button"
                    :disabled="isSaving||isLoading||isLoadingEdit"
                    @click="promptEnviarParaAprocacao()"
                >
                    {{ $t("enviar-para-aprovacao") }}
                    <button-loader :isSaving="isSaving" />
                </button>
                <button
                    v-if="!cantEdit"
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="isSaving||isLoading||isLoadingEdit"
                >
                    {{ $t("salvar") }}
                    <button-loader :isSaving="isSaving" />
                </button>
                <!-- Revisão prestação de contas -->
                <button
                    v-if="acertoDespesa.situacao==4 && isSupervisor && aprovacaoParcial != 0"
                    class="save-btn is-primary"
                    type="button"
                    :disabled="isSaving||isLoading||isLoadingEdit"
                    @click="promptRevisao()"
                >
                    {{ $t("enviar-para-revisao") }}
                    <button-loader :isSaving="isSaving" />
                </button>
                <!-- Aprovar prestação de contas -->
                <button
                    v-if="acertoDespesa.situacao==4 && isSupervisor && valorTotalDespesas>0"
                    class="save-btn is-approve"
                    type="button"
                    :disabled="isSaving||isLoading||isLoadingEdit"
                    @click="promptAprovar()"
                >
                    {{ $t("aprovar") }}
                    <button-loader :isSaving="isSaving" />
                </button>
                <!-- Reprovar prestação de contas -->
                <button
                    v-if="acertoDespesa.situacao==4 && isSupervisor"
                    class="save-btn is-deny"
                    type="button"
                    :disabled="isSaving||isLoading||isLoadingEdit"
                    @click="promptReprovar()"
                >
                    {{ $t("reprovar") }}
                    <button-loader :isSaving="isSaving" />
                </button>

                <b-tag
                    v-if="acertoDespesa.situacao<3"
                    class="table-tag table-tag-full-width"
                    :type="isStatusButtonType(acertoDespesa.situacao)"
                    size="is-medium"
                >
                    <span v-if="acertoDespesa.situacao == 0">
                        {{ $t('reprovado') }}
                    </span>
                    <span v-else-if="acertoDespesa.situacao == 1">
                        {{ $t('aprovado') }}
                    </span>
                    <span v-else-if="acertoDespesa.situacao == 2">
                        {{ $t('aprovado-parcial') }}
                    </span>
                </b-tag>

                <span
                    @click="isShowModalReprove = true"
                    v-if="
                        acertoDespesa.situacao == 0 &&
                        acertoDespesa.idmotivoregistro != 0 &&
                        acertoDespesa.idmotivoregistro != null
                    "
                    class="ml-2"
                >
                    <b-icon
                        class="is-clickable"
                        icon="comment-remove"
                        type="is-primary"
                        size="is-medium"
                        v-tippy 
                        :title="$t('desaprovado-por-n', { n: acertoDespesa.nomeusuariovalidacao })"
                    />
                </span>

            </div>
        </div>
        <div class="page page-container" v-if="!isLoadingEdit">
            <h3 v-if="$route.params.id" class="mb-4">
                {{ $t('codigo')}}: {{ acertoDespesa.iddes_acerto_despesaerp }}
                <br>
                {{ $t('colaborador')}}: {{ acertoDespesa.usuario.nome }}
            </h3>

            <div class="form-columns-fit">
                <div class="columns is-flex-wrap">
                    <div class="column is-12">
                        <vss-select
                            title="empresa"
                            ref="empresaSelect"
                            placeholder="selecione"
                            :options="empresaSelect"
                            v-model="empresaSelected"
                            :loading="empresaLoading"
                            :invalid="empresaSelected==null"
                            :disabled="!isNull($route.params.id)||cantEdit"
                        />
                    </div>
                    <div class="column is-9">
                        <v-input
                            :id="generateId(2)"
                            ref="descricaoInput"
                            placeholder="placeholder-preencha"
                            v-model="acertoDespesa.descricao"
                            :maxlength="50"
                            title="descricao"
                            required
                            :invalid="isNull(acertoDespesa.descricao)"
                            :disabled="cantEdit"
                        />
                    </div>
                    <div class="column is-3">
                        <verified-date-picker
                            :id="generateId(8)"
                            ref="datainicioSelect"
                            placeholder="selecione-uma-data"
                            v-model="acertoDespesa.datainicio"
                            required
                            :subtractDateDays="7"
                            :addDateDays="0"
                            :yearsRange="[-1, 1]"
                            title="data-inicio"
                            :inForm="true"
                            :showClean="false"
                            :disabled="cantEdit"
                            :invalid="!acertoDespesa.datainicio"
                        />
                    </div>
                    <div class="column is-12">
                        <v-textarea
                            ref="observacaoTextarea"
                            :id="generateId(50)"
                            v-model="acertoDespesa.observacao"
                            title="observacao-geral"
                            placeholder="placeholder-preencha"
                            :rows="4"
                            :maxRows="4"
                            :maxlength="500"
                            :disabled="cantEdit"
                        />
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal fotos da despesa -->
        <b-modal
            :active.sync="isShowModalReprove"
            @close="isShowModalReprove = false"
        >
            <div class="bg">
                <ModalMotivo
                    v-if="isShowModalReprove"
                    :id="acertoDespesa.id"
                    :idmotivoregistro="acertoDespesa.idmotivoregistro"
                    :descricao="acertoDespesa.descricao"
                    origem="ACERTO_DESPESA_INATIVO"
                    @fecharModal="isShowModalReprove = false"
                    @save="reprovar($event)"
                    @redirectMotivoReprovacao="redirectMotivoReprovacao"
                />
            </div>
        </b-modal>
    </div>
</template>

<script>
import AcertoDespesaService from "@/services/despesas/AcertoDespesaService";
import EmpresaService from "@/services/vendas/empresa/EmpresaService";
import ParametrizacaoService from "@/services/ParametrizacaoService";
import AcertoDespesaValidation from "@/services/validations/despesas/AcertoDespesaValidation.js";
import ModalMotivo from "@/components/despesas/acerto-despesa//modal/ModalMotivo.vue";
import AlertContainer from "@/components/shared/AlertContainer";
import Message from "@/models/Message";

export default {
    components: {
        AlertContainer,
        ModalMotivo
    },
    props: {
        valorTotalDespesas: {
            type: Number,
            default: 0,
        },
        valorTotalDespesasDebita_acerto: {
            type: Number,
            default: 0,
        },
        aprovacaoParcial: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes("DES_ACERTO_DESPESA"),
            validation: new AcertoDespesaValidation([]),
            service: new AcertoDespesaService(this.$http, this.$router),
            empresaService: new EmpresaService(this.$http, this.$router),
            serviceParametrizacao: new ParametrizacaoService(this.$http, this.$router),
            acertoDespesa: {
                id: 0,
                descricao: null,
                observacao: null,
                uuid: '',
                iddes_acerto_despesa: null,
                // situação 3 é em criação
                situacao: 3,
                datainicio: new Date(),
                origem: 'WEB',
                idmotivoregistro: 0,
                nomeusuariovalidacao: null,
            },
            // parametrização de aprovação automática
            parametrizacao: null,
            empresaSelect: [],
            empresaSelected: null,
            empresaLoading: false,
            usuarioSelected: null,
            permissao: null,
            isLoading: false,
            // para controlar algumas ações até os dados serem carregados na edição
            isLoadingEdit: true,
            isSaving: false,
            isEdit: false,
            isChanged: false,
            
            cantEdit: true,
            isSupervisor: false,
            isShowModalReprove: false,
        };
    },
    watch: {
        acertoDespesa: {
            deep: true,
            handler: function () {
                this.isChanged = true;
            },
        },
    },
    beforeRouteLeave(to, from, next) {
        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            "despesas",
            "prestacao-contas",
            "des-acerto-despesa"
        );

        !this.permissao.read &&
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "prestacao-contas" },
            });

        if (
            this.$route.params.id &&
            this.$route.params.name != "des-acerto-despesa-new"
        ) {
            this.carregarDados();
        }else{
            // libera a tela caso não seja edição
            this.isLoadingEdit = false;
            this.carregarEmpresa();
            this.cantEdit = false;
            this.$emit('cantEdit', false);
        }

    },
    methods: {
        generateId(numberId) {
            return this.$route.name + "-" + numberId;
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t("msg-tem-certeza-alteracoes"),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        carregaParametrizacao() {
            this.serviceParametrizacao
                .getConfigByNomeIdusuario('DESPESA_ACERTO_AUTOAPROVACAO', null)
                .then(({ content }) => {
                    this.parametrizacao = content.valor;
                    this.$emit('parametrizacao', this.parametrizacao)
                }).catch(e => {
                    this.$root.msgs.push(new Message("alert", 'msg-erro-carregar-param', true))
                })
        },
        carregarDados() {
            this.isLoadingEdit = true;
            this.$axios
                .get(`/despesa/acerto-despesa/${this.$route.params.id}.json`)
                .then((response) => {
                    this.acertoDespesa = response.data.content;
                    this.acertoDespesa.datainicio = new Date(this.acertoDespesa.datainicio);

                    this.$emit('acertoDespesa', this.acertoDespesa);
                    this.isChanged = false;
                })
                .catch((error) => {
                    this.acertoDespesa = null;
                    this.$root.msgs.push(new Message('error', 'msg-erro-load'));
                })
                .finally((_) => {
                    this.isLoadingEdit = false;
                    if(this.acertoDespesa!=null) {
                        this.empresaSelected = {
                            id: this.acertoDespesa.empresa.idempresa,
                            label: this.acertoDespesa.empresa.nome + ' - ' + this.acertoDespesa.empresa.rsocial,
                        }
                        // Valida edição
                        this.cantEdit = (this.acertoDespesa.situacao != 3 ||
                            this.$store.state.user.usuario.id != this.acertoDespesa.idusuario);
                        this.$emit('cantEdit', this.cantEdit);
                        // Valida se o usuário pode aprovar
                        let assusuariousuario = this.$store.state.user.usuario.assusuariousuarioList.map(m => m.idusuario);
                        this.isSupervisor = (this.$store.state.user.admin ||
                            assusuariousuario.includes(this.acertoDespesa.idusuario));
                        this.$emit('isSupervisor', this.isSupervisor);
                        this.$emit('recarregar', true);
                    }
                });
        },
        carregarEmpresa() {
            this.empresaLoading = true;
            this.empresaService.findEmpresaAssByIdUsuario(this.$store.state.user.usuario.id)
                .then(body => {
                    if(body.content) {
                        this.empresaSelect = body.content.map((m) => {
                            return {
                                id: m.idempresa,
                                label: m.nome + ' - ' + m.rsocial,
                            };
                        });
                    }
                })
                .catch(e => {
                    console.error('Erro ao carregar empresas.');
                })
                .finally(_ => {
                    this.empresaLoading = false;
                });
        },
        save() {
            this.isLoading = true;

            let acertoDespesaTemp = Object.assign(this.acertoDespesa);
            acertoDespesaTemp.observacao = this.mapTosave(acertoDespesaTemp.observacao);

            acertoDespesaTemp.datainicio =
                new Date(this.$moment(this.acertoDespesa.datainicio))
            acertoDespesaTemp.idempresa =
            this.empresaSelected != null ? this.empresaSelected.id : null;
            acertoDespesaTemp.idusuario = +this.$store.state.user.usuario.id;

            if (this.validation.validate(acertoDespesaTemp, this.$refs)) {
                this.isSaving = true;
                this.service.save(acertoDespesaTemp)
                    .then((body) => {
                        if (body.content) {
                            let msg = this.$t(
                                    this.acertoDespesa.iddes_acerto_despesa != null
                                        ? "msg-edit-sucesso-n"
                                        : "msg-save-sucesso-n", 
                                    { n: this.$t("prestacao-contas") }
                                );
                            this.$root.msgs.push(new Message("success", msg, true, false));
                            if(this.acertoDespesa.iddes_acerto_despesa == null) {
                                // manda para a edição para adicionar os items
                                this.redirectToEdit(body.content.iddes_acerto_despesa);
                            }
                        } else {
                            this.$root.msgs.push(
                                new Message(
                                    "error",
                                    "msg-problema-realizar-acao",
                                    true
                                )
                            );
                        }
                    })
                    .catch(_ => {
                        this.$root.msgs.push(new Message("error", "msg-erro-salvar-despesa"));
                    })
                    .finally(_ => {
                        this.isChanged = false;
                        this.isSaving = false;
                        if(this.acertoDespesa.iddes_acerto_despesa != null) {
                            this.carregarDados();
                        }
                        this.isLoading = false;
                    });
            } else {
                this.$root.msgs.push(new Message("alert", 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },
        promptEnviarParaAprocacao() {
            this.$root.confirm({
                message: this.$t('msg-confirma-enviar-para-aprovacao-n', 
                    { n: this.acertoDespesa.descricao }
                ),
                onConfirm: _ => this.enviarParaAprocacao(),
            });
        },
        enviarParaAprocacao() {
            // Caso esteja configurado a aprovação automática já muda a situação para aprovado
            // e como 'N' para enviar para o ERP
            if(this.acertoDespesa.valor_config == 'S') {
                this.aprovar();
                return;
            }
            this.isSaving = true;
            this.service.enviarParaAprocacao(this.acertoDespesa.uuid)
                .then((body) => {
                    if (body.content) {
                        let msg = this.$t('msg-sucesso-enviar-para-aprovacao-n', 
                            { n: this.$t("prestacao-contas") }
                        );
                        this.$root.msgs.push(new Message("success", msg, true, false));
                    } else {
                        throw new this.ErrorMsg('without-data');
                    }
                })
                .catch(_ => {
                    let msg = this.$t('msg-erro-enviar-para-aprovacao-n', 
                        { n: this.$t("prestacao-contas") }
                    );
                    this.$root.msgs.push(new Message("error", msg, true, false));
                })
                .finally(_ => {
                    this.isChanged = false;
                    this.isSaving = false;
                    this.isLoading = false;
                    this.carregarDados();
                });
        },
        promptRevisao() {
            this.$root.confirm({
                message: this.$t('msg-confirma-enviar-para-revisao-n', 
                    { n: this.acertoDespesa.descricao }
                ),
                onConfirm: _ => this.revisao(),
            });
        },
        revisao() {
            this.isSaving = true;
            this.service.enviarParaRevisao(this.acertoDespesa.uuid)
            .then((body) => {
                    if (body.content) {
                        let msg = this.$t('msg-sucesso-enviar-para-revisao-n', 
                            { n: this.$t("prestacao-contas") }
                        );
                        this.$root.msgs.push(new Message("success", msg, true, false));
                    } else {
                        throw new this.ErrorMsg('without-data');
                    }
                })
                .catch(_ => {
                    let msg = this.$t('msg-erro-enviar-para-revisao-n', 
                        { n: this.$t("prestacao-contas") }
                    );
                    this.$root.msgs.push(new Message("error", msg, true, false));
                })
                .finally(_ => {
                    this.isChanged = false;
                    this.isSaving = false;
                    this.isLoading = false;
                    this.carregarDados();
                });
        },
        promptAprovar() {
            this.$root.confirm({
                message: this.$t('msg-confirma-aprovar-n', { n: this.acertoDespesa.descricao }),
                onConfirm: _ => this.aprovar(),
            });
        },
        aprovar() {
            this.isSaving = true;
            this.service.aprovar(this.acertoDespesa.uuid, this.aprovacaoParcial)
                .then((body) => {
                    if (body.content) {
                        let msg = this.$t('msg-sucesso-aprovar-n', 
                            { n: this.$t("prestacao-contas") }
                        );
                        this.$root.msgs.push(new Message("success", msg, true, false));
                    } else {
                        throw new this.ErrorMsg('without-data');
                    }
                })
                .catch(_ => {
                    let msg = this.$t('msg-erro-aprovar-n', 
                        { n: this.$t("prestacao-contas") }
                    );
                    this.$root.msgs.push(new Message("error", msg, true, false));
                })
                .finally(_ => {
                    this.isChanged = false;
                    this.isSaving = false;
                    this.isLoading = false;
                    this.carregarDados();
                });
        },
        promptReprovar() {
            this.$root.confirm({
                message: this.$t('msg-confirma-reprovar-n', 
                    { n: this.acertoDespesa.descricao }
                ),
                onConfirm: _ => this.isShowModalReprove = true,
            });
        },
        reprovar(idmotivoregistro) {
            this.isSaving = true;
            this.service.reprovar(this.acertoDespesa.uuid, idmotivoregistro)
                .then((body) => {
                    if (body.content) {
                        let msg = this.$t('msg-sucesso-reprovar-n', 
                            { n: this.$t("prestacao-contas") }
                        );
                        this.$root.msgs.push(new Message("success", msg, true, false));
                    } else {
                        throw new this.ErrorMsg('without-data');
                    }
                })
                .catch(_ => {
                    let msg = this.$t('msg-erro-reprovar-n', 
                        { n: this.$t("prestacao-contas") }
                    );
                    this.$root.msgs.push(new Message("error", msg, true, false));
                })
                .finally(_ => {
                    this.isChanged = false;
                    this.isSaving = false;
                    this.isLoading = false;
                    this.carregarDados();
                });
        },
        redirectMotivoReprovacao() {
            setTimeout(() => {
                this.$router.push({
                    name: 'des-motivo-new',
                    query: { id: this.acertoDespesa.id, tela: 'prestacao-contas' },
                });
            }, 500);
        },
        redirectToEdit(id) {
            setTimeout(() => {
                this.$router.push({
                    name: 'des-acerto-despesa-edit',
                    params: { id: id },
                });
            }, 1000);
        },
        redirectToPage() {
            let tempTela = "des-acerto-despesa-list";
            let tempAba = null;
            if (this.$route.query.tela == "tela") {
                tempTela = "des-tela-edit";
                tempAba = "geral";
            }
            const route = {
                name: tempTela,
                params: { id: this.$route.query["id"] },
                query: {
                    abaSelecionada: tempAba
                },
            };
            setTimeout(() => {
                this.$router.push(route);
            }, 1000);
        },
        isStatusButtonType(status) {
            if (status == 0) return "is-danger";
            else if (status == 1) return "is-success";
            else if (status == 2) return "is-success";
            else if (status == 3) return "is-primary";
            else if (status == 4) return "is-warning";
        },
    },
};
</script>
